import { useContext, useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import cargoBike from "../assets/icons/cargo_bike.svg";
import net from "../assets/images/net.jpg";
import { Context } from "../ContextProvider";
import { LANGUAGE } from "../type";

const AnimatedIcon = () => {
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowIcon(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`${
        showIcon ? "translate-x-0" : "translate-x-full lg:translate-x-0"
      } transition-transform duration-[4000ms] linear lg:transition-none`}
    >
      <img src={cargoBike} alt="cargoBike" className="w-24 xl:w-36 h-full" />
    </div>
  );
};

const PurposeSection = () => {
  const { t } = useTranslation();
  const { language } = useContext(Context);

  return (
    <section className="mt-32 max-w-screen-2xl mx-auto xl:mt-44">
      <div className="px-6 flex gap-x-6 flex-col lg:flex-row lg:items-center 2xl:px-0">
        <div className="lg:basis-1/2">
          <h1 className="font-inter-regular text-allsafe-blue text-4xl leading-12 xl:text-6xl xl:leading-14">
            <Trans>Ladungssicherung im</Trans>
            <span className="font-black mx-1 2xl:mx-2">
              <Trans>cargobike</Trans>
            </span>
						!?
          </h1>
          <h2 className="font-inter-regular text-allsafe-blue text-2xl leading-10 my-4 xl:text-4xl xl:leading-14">
            <Trans>Wir meinen: Definitiv</Trans>!
          </h2>
          <p className="font-inter-regular text-base leading-6">
            {t(
              "Ob zwei, drei oder mehr Räder - eine professionelle Ladungssicherung ist ein Muss. Sie sorgt dafür, dass die Ware und vor allem der Fahrer unversehrt am Ziel ankommen. Mit unseren frei kombinierbaren Produkten entwickeln wir auch für die Sicherung Ihrer Ladung auf dem Cargobike das optimale Konzept. Entdecken Sie unser Angebot oder kontaktieren Sie uns. Gemeinsam finden wir Ihre individuelle Lösung.",
            )}
          </p>
          {language !== LANGUAGE.FR && (
            <div className="flex flex-col mt-4 lg:items-center lg:gap-x-4 2xl:gap-x-8 lg:flex-row">
              <div className="w-[84%] lg:w-16 xl:w-36 h-26 lg:shrink-0">
                <AnimatedIcon />
              </div>
              <p className="font-inter-regular text-base leading-6">
                <Trans>Entdecken Sie unser gesamtes Sortiment in unserem</Trans>
                <a
                  href={
                    language === LANGUAGE.DE
                      ? "https://cms.allsafe24.com/assets/ef1a4fa0-237b-4e9a-bf80-df2f7fd2f9f6.pdf"
                      : "https://cms.allsafe24.com/assets/e26510ec-e189-4954-9ad7-6dc2283b6dd6?download"
                  }
                  className="text-allsafe-blue cursor-pointer mx-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans>Katalog</Trans>
                </a>
                <Trans>oder werfen Sie einen Blick auf unseren</Trans>
                <a
                  href={
                    language === LANGUAGE.DE
                      ? "https://cms.allsafe24.com/assets/567cd6e5-f907-4c7d-a963-00d89b63eb58?"
                      : "https://cms.allsafe24.com/assets/d47d6bf0-71ab-4d1e-b7a3-ad86b4daade9?download"
                  }
                  className="text-allsafe-blue cursor-pointer ml-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Trans>Cargobike-Flyer</Trans>
                </a>
								.
              </p>
            </div>
          )}
        </div>
        <div className="w-full h-44 shrink-0 sm:h-96 lg:h-[500px] lg:basis-3/5 2xl:basis-[920px] mt-8 xl:mt-0">
          <img src={net} alt="net" className="w-full h-full object-cover" />
        </div>
      </div>
    </section>
  );
};

export default PurposeSection;
